import Environment from "./environment";
Environment.initialize();

